/**
 * Utility helpers for translating branding colors into CSS variables.
 */
const normalizeHexColor = (hexColor) => {
    if (!hexColor) return null;
    let hex = hexColor.trim().replace('#', '');

    if (hex.length === 3) {
        hex = hex.split('').map((char) => char + char).join('');
    }

    if (hex.length !== 6) {
        return null;
    }

    return `#${hex.toLowerCase()}`;
};

export const adjustColorBrightness = (hexColor, amount = 0) => {
    const normalized = normalizeHexColor(hexColor);
    if (!normalized) return hexColor;

    const numericColor = parseInt(normalized.slice(1), 16);
    let r = (numericColor >> 16) + amount * 255;
    let g = ((numericColor >> 8) & 0x00ff) + amount * 255;
    let b = (numericColor & 0x0000ff) + amount * 255;

    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));

    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};

export const hexToRgba = (hexColor, alpha = 1) => {
    const normalized = normalizeHexColor(hexColor);
    if (!normalized) return null;

    const numericColor = parseInt(normalized.slice(1), 16);
    const r = (numericColor >> 16) & 255;
    const g = (numericColor >> 8) & 255;
    const b = numericColor & 255;

    const safeAlpha = Math.max(0, Math.min(1, alpha));
    return `rgba(${r}, ${g}, ${b}, ${safeAlpha})`;
};

export const applyBrandingColors = (primaryColor) => {
    if (typeof document === 'undefined' || !primaryColor) return;

    const hoverColor = adjustColorBrightness(primaryColor, -0.1);
    const focusColor = adjustColorBrightness(primaryColor, -0.05) || primaryColor;
    const softColor = hexToRgba(primaryColor, 0.12);
    const strongSoftColor = hexToRgba(primaryColor, 0.2);
    const outlineColor = hexToRgba(primaryColor, 0.35);

    const root = document.documentElement;
    const setVar = (name, value) => {
        if (!value) return;
        root.style.setProperty(name, value);
    };

    setVar('--primary-color', primaryColor);
    setVar('--primary-hover', hoverColor);
    setVar('--primary-focus', focusColor);
    setVar('--primary-soft', softColor);
    setVar('--primary-soft-strong', strongSoftColor);
    setVar('--primary-outline', outlineColor);
};
